import React from 'react';
import ProductCollection from '../sections/ProductCollection';

/**
 * CategoryPage
 * Rendered at /men, /women, /unisex, /all, /sale
 *
 * Props:
 *  - category: 'men' | 'women' | 'unisex' | 'all'
 *  - onAddToCart: function
 *  - sale (optional): boolean — reserved for future sale filtering
 */
const CATEGORY_META = {
  all:    { label: 'All Products',    description: 'Browse our full collection of premium medical apparel.' },
  men:    { label: "Men's Collection", description: 'Performance scrubs and coats designed for the modern male healthcare professional.' },
  women:  { label: "Women's Collection", description: 'Stylish, functional scrubs and coats crafted for women in healthcare.' },
  unisex: { label: 'Unisex Collection', description: 'Versatile styles made to fit and flatter every body.' },
};

const CategoryPage = ({ category, onAddToCart, sale }) => {
  const meta = CATEGORY_META[category] || CATEGORY_META.all;

  return (
    <div className="bg-navy min-h-screen">
      {/* Category Hero Banner */}
      <div className="bg-navy-light border-b border-primary/20 py-12">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-4xl font-bold text-teal-400 mb-3">
            {sale ? '🔖 Sale' : meta.label}
          </h1>
          <p className="text-teal-400 text-lg max-w-xl mx-auto">
            {sale ? 'Discounted items across all categories.' : meta.description}
          </p>
        </div>
      </div>

      {/* Product grid — reuses ProductCollection with category prop */}
      <ProductCollection
        onAddToCart={onAddToCart}
        category={category}
        sale={sale}
      />
    </div>
  );
};

export default CategoryPage;